import { Button, ButtonColorVariant, ButtonSize, ButtonVariant, Modal } from "@next-platform/client-common-spicy-ui";
import { useTranslation } from "@next-platform/client-common-core";

import Trans from "@/components/Trans/Trans";

interface IRemoveImageConfirmationModalProps {
  isOpen: boolean;
  isLoading: boolean;
  onClose: (isOpen: boolean) => void;
  onConfirm: () => Promise<void> | void;
}

export const RemoveImageConfirmationModal = ({ isOpen, isLoading, onClose, onConfirm }: IRemoveImageConfirmationModalProps) => {
  const { t } = useTranslation();
  return (
    <Modal
      title={t("chat:modal.removeImage.title")}
      description={t("chat:modal.removeImage.description")}
      className="dark:!bg-gray-6"
      dismissable={!isLoading}
      open={isOpen}
      onOpenChange={onClose}
    >
      <div className="flex justify-end gap-sm">
        <Button variant={ButtonVariant.OUTLINED} onClick={() => onClose(false)} size={ButtonSize.LARGE} disabled={isLoading}>
          <Trans i18nKey="common:cancel" />
        </Button>
        <Button onClick={onConfirm} color={ButtonColorVariant.ERROR} loading={isLoading} size={ButtonSize.LARGE}>
          <Trans i18nKey="chat:modal.removeImage.cta.remove" />
        </Button>
      </div>
    </Modal>
  );
};
